import React from 'react';

interface DateSeparatorProps {
    label: string;
}

/** Centered calendar **/
const DateSeparator: React.FC<DateSeparatorProps> = ({ label }) => {
    return (
        <div className="flex w-full items-center justify-center px-4 py-3">
            <span className="rounded-full bg-slate-300/80 px-3 py-1 text-center text-[11px] font-medium leading-none text-slate-600 shadow-sm">
                {label}
            </span>
        </div>
    );
};

export default DateSeparator;
